import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getGroupScholasticAllAmericanInvitesData from './GetGroupScholasticAllAmericanInvitesData';
import getGroupScholasticAllAmericanInviteWorkflowData from '../GetWorkFlowByIdData';
import putGroupScholasticAllAmericanInviteWorkflowData from '../PutWorkFlowData';

const GroupScholasticAllAmericanInviteData = {
  INITIAL_STATE: {...BASIC_INITIAL_STATE},
  getGroupScholasticAllAmericanInvitesData,
  getGroupScholasticAllAmericanInviteWorkflowData,
  putGroupScholasticAllAmericanInviteWorkflowData
};

export default GroupScholasticAllAmericanInviteData;